import { render, staticRenderFns } from "./QuicReplies.vue?vue&type=template&id=7151f60c"
import script from "./QuicReplies.vue?vue&type=script&lang=js"
export * from "./QuicReplies.vue?vue&type=script&lang=js"
import style0 from "./QuicReplies.vue?vue&type=style&index=0&id=7151f60c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports